import { useCallback, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'src/AppContext';
import { parse } from 'querystring';
import Button from 'src/components/Button';
import { reSendVerification } from 'src/services/api';
import { getURLInQueryString } from 'src/services/util';
import { Trans, useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useModal } from 'src/ModalContext';

export default function EmailLink(): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const history = useCustomHistory();
  const qs = location.search.replace(/^[?]/gi, '');
  const { email } = parse(qs);
  const verificationResendUrl = getURLInQueryString(qs, 'verificationResendUrl');
  const { showModal } = useModal();

  const onResend = useCallback(() => {
    showModal({
      message: t('account/complete/resend_confirm'),
      success: () => {
        reSendVerification(verificationResendUrl as string)
          .then((res) => {
            if (res.status === 200) {
              showModal({
                message: t('account/complete/resend_verify_email_success'),
                success: () => {
                  console.log('success');
                },
              });
            }
          })
          .catch((e) => {
            console.error(e);
            showModal({
              title: `[${t('account/complete/send_error_title')}]`,
              message: t('account/complete/resend_verify_email_fail'),
              success: () => {
                console.log('success');
              },
            });
          });
      },
      fail: () => {
        console.log('fail');
      },
    });
  }, [verificationResendUrl]);

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.push('/login');
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  return (
    <>
      <div className="container mt-6">
        <h1 className="N_20_R">{t('email-link/title')}</h1>
        <div className="mt-7 N_14_R text-brown-grey">
          <Trans
            i18nKey="account/complete/subtitle_1"
            components={{ span: <span className="text-bluey-purple font-medium" /> }}
            values={{ email }}
          ></Trans>
        </div>
        <div className="mt-4 N_14_R text-brown-grey">
          <Trans
            i18nKey="account/complete/subtitle_2"
            components={{ span: <span className="text-greyish-brown font-medium" /> }}
            values={{ button: `[${t('account/complete/verify_email_button')}]` }}
          ></Trans>
        </div>
        <div className="mt-10">
          <Button title={t('account/complete/resend_verify_email_button')} onClick={onResend}></Button>
        </div>
        {/* <a className="btn-blue" href={verificationResendUrl as string}>인증메일 재전송</a> */}
      </div>
      <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
        <li>
          <div>
            <Trans
              i18nKey="account/complete/disclaimer_3"
              components={{ span: <span className="text-greyish-brown font-medium" /> }}
              values={{
                button: `[${t('account/complete/resend_verify_email_button')}]`,
              }}
            ></Trans>
          </div>
        </li>
        <li>{t('account/complete/disclaimer_4')}</li>
      </ul>
    </>
  );
}
